const tryCatch = (fn: () => any, fallback?: any) => {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
};

export default tryCatch;
